<template>
  <div>
    <input
      type="text"
      class="form-control form-control-lg"
      :value="value"
      @input="input">
  </div>
</template>

<script>
export default {
  name: 'InputText',
  props: {
    value: {
      type: String
    }
  },
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    input (el) {
      this.$emit('input', el.target.value)
    }
  }
}
</script>

<style scoped>
</style>
